import React, {useEffect, useState, useContext} from 'react';
import {Block} from '../block';
import {Typography, Spin, Input, Button} from 'antd';
import {map, cloneDeep} from 'lodash';
import {PlusOutlined} from '@ant-design/icons';
import {OpenApiContext} from '../../openapi-context';

export function ContactBlock({contactData, className, onSave, onCancel}) {
    const [contactArray, setContactArray] = useState();
    const {state, dispatch} = useContext(OpenApiContext);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (contactData && contactData.contact) {
            setContactArray(cloneDeep(contactData.contact));
        }
    }, [contactData]);

    function handleSave() {
        dispatch({type: 'terminate'});
        return onSave && onSave(contactArray);
    }

    function handleCancel() {
        if (contactData && contactData.contact) {
            setContactArray(cloneDeep(contactData.contact));
        }
        dispatch({type: 'terminate'});
        return onCancel && onCancel();
    }

    const triggerEdit = () => dispatch({type: 'activate', message: `changes to specification contacts`});

    useEffect(() => {
        setIsLoading(false);
    });

    //Add server
    const addServer = () => {
        setIsLoading(true);
        let arrayTemp = contactArray;
        const contact = {
            name: '',
            url: '',
            email: '',
        };
        arrayTemp.push(contact);
        setContactArray(arrayTemp);
    };

    //Delete contact
    const deleteContact = (key) => {
        setIsLoading(true);
        let arrayTemp = contactArray;
        arrayTemp.splice(key, 1);
        setContactArray(arrayTemp);
    };

    //Save Name
    const saveName = (value, key) => {
        contactArray[key].name = value;
        setContactArray(contactArray);
    };

    //Save url
    const saveUrl = (value, key) => {
        contactArray[key].url = value;
        setContactArray(contactArray);
    };

    //Save Email
    const saveEmail = (value, key) => {
        contactArray[key].email = value;
        setContactArray(contactArray);
    };

    const ContactEdit = () => {
        return (
            <div className="frontpage">
                <div>
                    {isLoading && <Spin size="large" />}
                    <div className="serverView">
                        <Typography.Title level={2}>Contact Infos</Typography.Title>
                        <Button disabled={false} type="secondary" className="titleIcon" icon={<PlusOutlined />} onClick={addServer} />
                    </div>
                    {contactArray &&
                        map(contactArray, (item, key) => {
                            return (
                                <div style={{marginBottom: 16}} key={key}>
                                    <Input.Group compact size="large" style={{display: 'flex', flexDirection: 'row'}}>
                                        <Input
                                            style={{width: '60%', marginBottom: '15px'}}
                                            defaultValue={item.name}
                                            placeholder="Contact Name"
                                            onChange={(event) => saveName(event.target.value, key)}
                                        />
                                        <Input defaultValue={item.url} onChange={(event) => saveUrl(event.target.value, key)} style={{width: '60%', marginBottom: '15px'}} placeholder="Contact Url" />
                                        <Input
                                            defaultValue={item.email}
                                            onChange={(event) => saveEmail(event.target.value, key)}
                                            style={{width: '60%', marginBottom: '15px'}}
                                            placeholder="Contact Email"
                                        />
                                    </Input.Group>
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    };

    const ContactView = () => {
        return (
            <div className="frontpage">
                <div>
                    <div className="serverView">
                        <Typography.Title level={2}>Contact Infos</Typography.Title>
                    </div>
                    {map(contactArray, (item, key) => {
                        return (
                            <div style={{marginBottom: 16}} key={key}>
                                <Typography.Paragraph level={4}>{item.name || ''}</Typography.Paragraph>
                                <Typography.Paragraph>
                                    <a href={item.url}>{item.url || ''}</a>
                                </Typography.Paragraph>
                                <Typography.Paragraph>
                                    <a href={`mailto:${item.email}`}>{item.email || ''}</a>
                                </Typography.Paragraph>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return contactData ? (
        <Block className={className} onCancel={handleCancel} onSave={handleSave} onEdit={triggerEdit}>
            {state.editMode ? <ContactEdit /> : <ContactView />}
        </Block>
    ) : null;
}
